import React from 'react';
import { Navigate } from 'react-router-dom';
import { getCurrentUser } from '../services/api';

const PrivateRoute = ({ children }) => {
    const user = getCurrentUser();
    
    if (!user || user.role !== 'admin') {
        return <Navigate to="/admin/login" />;
    }
    
    return children;
};

export default PrivateRoute;